import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=646ca2e4&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=646ca2e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ca2e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('646ca2e4')) {
      api.createRecord('646ca2e4', component.options)
    } else {
      api.reload('646ca2e4', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=646ca2e4&scoped=true", function () {
      api.rerender('646ca2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/orderStatistics/Statistics.vue"
export default component.exports